import './bootstrap';
import './main';
import './header';
import './header-2023';
import './progress';
import '@splidejs/splide/dist/js/splide.js';
import './gallery';
import './mousemove';
import './burger';
import 'bootstrap/js/src/collapse';

// Import CSS files if they weren't imported elsewhere
import '../sass/app.scss';

// Expose to window object
import('bootstrap/js/dist/modal').then(module => {
    window.Modal = module;
});

import('./home-script').then(module => {
    window.HomeScript = module;
});
